import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import FeatureHighlight from "../../components/cultivars/FeatureHighlight";
import ProductShowcase from "../../components/cultivars/FruityPebbles2/ProductShowcase";
import CultivarDisplay from "../../components/cultivars/CultivarDisplay";
import Cta from "../../components/Cta";

const FruityPebbles2 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Fruity Pebbles 2.0 - Premium Cannabis Cultivar | BeyondBloom™</title>
        <meta name="description" content="Discover Fruity Pebbles 2.0, a top-tier cannabis cultivar with a burst of fruity flavors and a smooth, balanced effect. Perfect for relaxation and creativity." />
        <meta name="keywords" content="Fruity Pebbles 2.0, cannabis, premium cultivar, BeyondBloom, hybrid strain, fruity flavor, top cannabis strains" />
        <meta name="author" content="BeyondBloom™" />

        {/* Open Graph (Facebook & LinkedIn) */}
        <meta property="og:title" content="Fruity Pebbles 2.0 - Premium Cannabis Cultivar | BeyondBloom™" />
        <meta property="og:description" content="Discover Fruity Pebbles 2.0, a top-tier cannabis cultivar with a burst of fruity flavors and a smooth, balanced effect. Perfect for relaxation and creativity." />
        <meta property="og:image" content="/images/fruity-pebbles-2-0.png" />
        <meta property="og:url" content="https://yourwebsite.com/fruity-pebbles-2-0" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Fruity Pebbles 2.0 - Premium Cannabis Cultivar | BeyondBloom™" />
        <meta name="twitter:description" content="Discover Fruity Pebbles 2.0, a top-tier cannabis cultivar with a burst of fruity flavors and a smooth, balanced effect. Perfect for relaxation and creativity." />
        <meta name="twitter:image" content="/images/fruity-pebbles-2-0.png" />
      </Helmet>

      <Navbar />
      <ProductShowcase />
      <FeatureHighlight />
      <CultivarDisplay />
      <Cta />
      <Footer />
    </>
  );
};

export default FruityPebbles2;
